import styled from 'styled-components';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { ModalProps } from 'react-bootstrap/Modal';

export const Modal = styled(BootstrapModal)<ModalProps>`
  .modal-content {
    background-color: white;
  }

  .modal-header {
    border-bottom-color: transparent !important;
  }

  .modal-footer {
    border-top-color: transparent !important;
  }
`;
